import { Record } from "../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, lambda_type, unit_type, obj_type } from "../fable_modules/fable-library.3.7.20/Reflection.js";
import redux_thunk from "redux-thunk";
import { createStore as createStore_1, combineReducers as combineReducers_1, applyMiddleware as applyMiddleware_1 } from "redux";
import { composeEnhancers as composeEnhancers_1 } from "../../src/Redux/composeEnhancers.js";
import { createThunk as createThunk_1 } from "../../src/Redux/createThunk.js";
import { value as value_2 } from "../fable_modules/fable-library.3.7.20/Option.js";

export class IStore$1 extends Record {
    constructor(dispatch, getState, subscribe) {
        super();
        this.dispatch = dispatch;
        this.getState = getState;
        this.subscribe = subscribe;
    }
}

export function IStore$1$reflection(gen0) {
    return record_type("Redux.Redux.IStore`1", [gen0], IStore$1, () => [["dispatch", lambda_type(obj_type, unit_type)], ["getState", lambda_type(unit_type, gen0)], ["subscribe", lambda_type(lambda_type(unit_type, unit_type), lambda_type(unit_type, unit_type))]]);
}

export const thunk = redux_thunk;

export const applyMiddleware = applyMiddleware_1;

export const combineReducers = combineReducers_1;

export const composeEnhancers = composeEnhancers_1;

export const createStore = createStore_1;

export function createAction(reducerName, value) {
    return {
        Value: value,
        type: reducerName,
    };
}

export const createThunk = createThunk_1;

export function createReducer(reducerName, initState, stateOpt, action, reducer) {
    if (stateOpt != null) {
        const state = value_2(stateOpt);
        if (action.type === reducerName) {
            return reducer(state, action.Value);
        }
        else {
            return state;
        }
    }
    else {
        return initState;
    }
}

